export default __webpack_public_path__ + "static/media/noun_teeth whitening_2531653.9f59f60b.png";